import { PayrollIncidenceDetailsPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

const useIncidenceRuleEvaluation = (
  incidenceId: string,
  employeeId: string,
  legalEntityId: string,
  companyId: string
) => {
  const { loading, data } = useQuery(PayrollIncidenceDetailsPageDocument, {
    variables: {
      id: incidenceId,
      employeeId: employeeId,
      legalEntityId: legalEntityId,
      companyId: companyId,
    },
  })
  const ruleEvaluation = data?.bookkeepersManagement?.incidencesConnection.nodes[0]?.ruleEvaluation

  return { loading, ruleEvaluation }
}

export default useIncidenceRuleEvaluation
